import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import logo from "../../assets/images/logo.svg";
import logosm from "../../assets/images/logosm.svg";
import megamenuImg from "../../assets/images/megamenu-img.png";
import { toggleRightSidebar } from "../../store/actions";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearch: false,
            isMegaMenu: false,
            isProfile: false,
        };
        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleRightbar = this.toggleRightbar.bind(this);
        this.toggleFullscreen = this.toggleFullscreen.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
    }

    toggleSearch = () => {
        this.setState({ isSearch: !this.state.isSearch });
    }

    toggleMenu() {
        this.props.openLeftMenuCallBack();
    }

    toggleRightbar() {
        this.props.toggleRightSidebar();
    }

    toggleFullscreen() {
        if (
            !document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                );
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <header id="page-topbar">
                    <div className="navbar-header">
                        <div className="d-flex">
                            <div className="navbar-brand-box py-3">
                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src={logosm} alt="" height="32" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logo} alt="" height="32" />
                                    </span>
                                </Link>
                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img src={logosm} alt="" height="32" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logo} alt="" height="32" />
                                    </span>
                                </Link>
                            </div>
                            <button
                                type="button"
                                className="btn px-3 font-size-24 d-lg-none header-item"
                                onClick={this.toggleMenu}
                                data-toggle="collapse"
                                data-target="#topnav-menu-content"
                            >
                                <i className="ri-menu-2-line align-middle"></i>
                            </button>
                            <div className="dropdown dropdown-mega d-none d-lg-block ms-2">
                                <button
                                    type="button"
                                    className="btn header-item waves-effect dropdown-toggle"
                                    id="megaMenuDropdown"
                                    aria-haspopup="true"
                                    aria-expanded={this.state.isMegaMenu}
                                    onClick={() => this.setState({ isMegaMenu: !this.state.isMegaMenu })}
                                >
                                    {this.props.t('Mega Menu')} <i className="mdi mdi-chevron-down"></i>
                                </button>
                                <div
                                    className={`dropdown-menu dropdown-megamenu${this.state.isMegaMenu ? " show" : ""}`}
                                    aria-labelledby="megaMenuDropdown"
                                >
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h5 className="font-size-14 mt-0">{this.props.t('UI Components')}</h5>
                                                    <ul className="list-unstyled megamenu-list">
                                                        <li><Link to="#">{this.props.t('Lightbox')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Range Slider')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Rating')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Forms')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Tables')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Charts')}</Link></li>
                                                    </ul>
                                                </div>
                                                <div className="col-md-4">
                                                    <h5 className="font-size-14 mt-0">{this.props.t('Applications')}</h5>
                                                    <ul className="list-unstyled megamenu-list">
                                                        <li><Link to="#">{this.props.t('Ecommerce')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Calendar')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Email')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Projects')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Tasks')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Contacts')}</Link></li>
                                                    </ul>
                                                </div>
                                                <div className="col-md-4">
                                                    <h5 className="font-size-14 mt-0">{this.props.t('Extra Pages')}</h5>
                                                    <ul className="list-unstyled megamenu-list">
                                                        <li><Link to="#">{this.props.t('Light Sidebar')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Compact Sidebar')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Horizontal layout')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Maintenance')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Coming Soon')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Timeline')}</Link></li>
                                                        <li><Link to="#">{this.props.t('FAQs')}</Link></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <h5 className="font-size-14 mt-0">{this.props.t('UI Components')}</h5>
                                                    <ul className="list-unstyled megamenu-list">
                                                        <li><Link to="#">{this.props.t('Lightbox')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Range Slider')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Rating')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Forms')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Tables')}</Link></li>
                                                        <li><Link to="#">{this.props.t('Charts')}</Link></li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        <img src={megamenuImg} alt="" className="img-fluid mx-auto d-block" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="logo-lg align-items-center">
                                <img src={logo} alt="" height="126" />
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="dropdown ms-1 center-items m-auto">
                                <Link className="waves-effect btn btn-info"> Add stock </Link>
                            </div>
                        </div>
                    </div>
                </header>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { layoutType } = state.Layout;
    return { layoutType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(withTranslation()(Header));
